import axios from 'axios';

axios.defaults.baseURL = 'https://backend.elmeckcables.com/'
//axios.defaults.baseURL = 'http://localhost:30928/'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/json';


if (localStorage.getItem('accessToken')) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken');
}


let api = {

    role: {
        createRole: (data) => axios.post('panel/role', data),
        listRole: (data) => axios.post('panel/role/list', data),
        deleteRole: (data) => axios.delete('panel/role/' + data),
        editRole: (id, data) => axios.patch('panel/role/' + id, data),
        getPermission: (data) => axios.get('panel/role/' + data)
    },
    user: {
        login: (data) => axios.post('panel/user/login', data),
        userList: (data) => axios.post('panel/user/list', data),
        createUser: (data) => axios.post('panel/user', data),
        deleteUser: (data) => axios.delete('panel/user/' + data),
        editUser: (id, data) => axios.patch('panel/user/' + id, data)
    },
    product: {
        createProduct: (data) => axios.post('panel/product', data),
        productNameList: (data) => axios.get('panel/product/name', data),
        getProductList: (data) => axios.post('panel/product/list', data),
        getProduct: (id) => axios.get('panel/product/' + id),
        deleteProduct: (data) => axios.delete('panel/product/' + data),
        editProduct: (id, data) => axios.patch('panel/product/' + id, data)
    },
    qr: {
        qrList: (data) => axios.post('panel/qr-code/list', data),
        createQr: (data) => axios.post('panel/qr-code', data),
        downloadQr: (data) => axios.get('panel/qr-code/excel/' + data),
        deleteQr: (data) => axios.delete('panel/qr-code/' + data)
    },
    scheme: {
        addSchemes: (data) => axios.post('panel/scheme', data),
        listScheme: (data) => axios.post('panel/scheme/list', data),
        deleteScheme: (data) => axios.delete('panel/scheme/' + data),
        getScheme: (data) => axios.get('panel/scheme/' + data),
        editScheme: (id, data) => axios.patch('panel/scheme/' + id, data)
    },
    Scanned: {
        listScanned: (data) => axios.post('panel/scanned-qr/list', data),
        stats: (data) => axios.post('panel/scanned-qr/stats', data),
    },
    Redeem: {
        listRedeem: (data) => axios.post('panel/redeem/list', data),
        updateRedeemStatus: (id, data) => axios.patch('panel/redeem/' + id, data),
        revertToPending: (id) => axios.patch('panel/redeem/' + id + '/revert'),
        refreshPayoutStatus: (id) => axios.get('panel/redeem/' + id + '/payout-status'),
        userName: (data) => axios.get('panel/redeem/user-name', { params: data }),
        schemeName: (data) => axios.get('panel/redeem/scheme-name', { params: data })
    },
    appRole: {
        roles: () => axios.get('web/config/setting')
    },
    appUser: {
        create: (data) => axios.post('panel/app-user', data),
        get: (data) => axios.get('panel/app-user/' + data),
        list: (data) => axios.post('panel/app-user/list', data),
        stats: (data) => axios.post('panel/app-user/stats', data),
        pincodeOptions: (params) => axios.get('panel/app-user/pincode-options', { params }),
        update: (id, data) => axios.patch('panel/app-user/' + id, data),
        remove: (data) => axios.delete('panel/app-user/' + data),
    },
    activityLogs: {
        list: (data) => axios.post('panel/activity-log/list', data),
        remove: (data) => axios.delete('panel/activity-log/' + data)
    },
    about: {
        add: (data) => axios.post('panel/about', data),
        list: (data) => axios.post('panel/about/list', data),
        update: (id, data) => axios.patch('panel/about/' + id, data)

    },
    state: {
        list: (data) => axios.get('web/state', { params: data }),
        panelList: () => axios.get('panel/state'),
        add: (data) => axios.post('panel/state', data),
        update: (id, data) => axios.patch('panel/state/' + id, data),
        remove: (id) => axios.delete('panel/state/' + id),
    },
    config: {
        get: (data) => axios.get('panel/config/' + data),
        update: (id, data) => axios.patch('panel/config/' + id, data),
    },
    employee: {
        list: () => axios.get('panel/cluster/employee'),
        create: (data) => axios.post('panel/cluster/employee', data),
        update: (id, data) => axios.patch('panel/cluster/employee/' + id, data),
        remove: (id) => axios.delete('panel/cluster/employee/' + id),
    },
    cluster: {
        list: () => axios.get('panel/cluster'),
        create: (data) => axios.post('panel/cluster', data),
        update: (id, data) => axios.patch('panel/cluster/' + id, data),
        remove: (id) => axios.delete('panel/cluster/' + id),
        dashboard: (params) => axios.get('panel/cluster/dashboard', { params }),
        map: (params) => axios.get('panel/cluster/map', { params }),
        states: (params) => axios.get('panel/cluster/states', { params }),
        coverage: (params) => axios.get('panel/cluster/coverage', { params }),
        autoGenerate: (data) => axios.post('panel/cluster/auto-generate', data),
        rebalance: () => axios.post('panel/cluster/rebalance'),
        pincodeInfo: (data) => axios.post('panel/cluster/pincode-info', data),
        scanTrends: (id, params) => axios.get('panel/cluster/' + id + '/scan-trends', { params }),
        monthScanners: (id, params) => axios.get('panel/cluster/' + id + '/month-scanners', { params }),
    },
    pincodeClient: {
        clients: (params) => axios.get('panel/pincode-client/clients', { params }),
        pincodes: () => axios.get('panel/pincode-client/pincodes'),
        getMapping: () => axios.get('panel/pincode-client/mapping'),
        saveMapping: (data) => axios.post('panel/pincode-client/mapping', data),
        report: (params) => axios.get('panel/pincode-client/report', { params }),
        territoryHealth: (params) => axios.get('panel/pincode-client/territory-health', { params }),
        pincodeElectricians: (params) => axios.get('panel/pincode-client/pincode-electricians', { params }),
    }
};

export default api;